import { Injectable } from '@angular/core';
import { Observable, Subject, filter, lastValueFrom, map } from 'rxjs';
import { IFastAPIService } from 'src/app/core/service';
import { FastAPIRepository } from '../repository/fast-api.repository';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs';
import Point from '@arcgis/core/geometry/Point';

interface DataSource {
  SourceName: string;
  SourceURL: string;
  SourceICON: string;
}

@Injectable()
export class FastAPIService extends IFastAPIService {
  public currentQuestion: string = '';
  private dataSource: DataSource[] = [];
  constructor(private fastApiRepository: FastAPIRepository, private http: HttpClient) {
    super();
  }

  updateCurrentQuestion(question: string) {
    this.currentQuestion = question;
  }
  getCurrentQuestion(): string {
    return this.currentQuestion;
  }

  private subscription: Subscription = new Subscription();


  getAISearchResult(question: string): [Observable<any>, Observable<any>] {
    this.subscription.unsubscribe();
    const dataStream = new Subject<any>();
    const configStream = new Subject<any>();
    let currentIndex = -1;

    this.subscription = this.fastApiRepository.getAISearch(question).pipe(
      filter(event => event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.Response),
      map(event => {
        if (event.type === HttpEventType.Response) {
          return event.body;
        } else if (event.type === HttpEventType.DownloadProgress) {
          const responseText = (event as any).partialText;
          return responseText;
        }
      })
    ).subscribe({
      next: (chunk: string) => {
        const lines = chunk.split('\n');
        lines.forEach(line => {
          if (line.trim().length > 0) {
            try {
              const parsedLine = JSON.parse(line);
              if (parsedLine.type == "Result") {
                if (currentIndex < parsedLine.event_id) {
                  dataStream.next(parsedLine);
                  currentIndex = parsedLine.event_id;
                }
              } else if (parsedLine.type == "Information") {
                configStream.next(parsedLine);
                configStream.complete();
              }
            } catch (e) {
              console.error('Error parsing JSON:', e);
            }
          }
        });
      },
      error: (error: any) => {
        console.error('Error in streaming:', error);
        dataStream.error(error);
        configStream.error(error);
      },
      complete: () => {
        dataStream.complete();
        configStream.complete();
      }
    });
    return [dataStream.asObservable(), configStream.asObservable()];
  }

  async getALLLatLon(): Promise<News[]> {
    const searchResponse: any = await lastValueFrom(this.fastApiRepository.getSearch("*", 0, 1000, "lat-lon"));
    if (!searchResponse.response) return [];
    let docs: News[] = searchResponse.response.response.docs;
    return docs
  }


  async getSearchResult(question: string, start: number, rows: number, returnFieldType: string = "full", saveQuestion: boolean = false): Promise<Results> {
    question = question.replace(':', '')
    let results = new Results();
    if (!question.length) return results;
    if (saveQuestion) this.saveQuestion(question, 0).subscribe();
    const searchResponse: any = await lastValueFrom(this.fastApiRepository.getSearch(question, start, rows, returnFieldType));
    if (!searchResponse.response) return results;
    results.numFound = searchResponse.response.response.numFound;
    let docs: News[] = searchResponse.response.response.docs;
    let views: Map<string, number> = new Map();
    for (let index of docs) {

      console.log(index)
      if (index.ScrapingType == 'File') {
        index.icon = "assets/search-component-images/fi_file-text.svg"
        index.sourceName = "File"
      }
      else {
        if (index.ScrapingType == "Social-Media") {
          index.icon = index.Picture_URL_OD[0]
          index.sourceName = index.Picture_Alt_OD[0]
        }
        else {
          index.icon = await this.getFavicon(index.Link_OD);
          index.sourceName = this.getSourceDomain(index.Link_OD)
        }
      }

      if (returnFieldType == "full") {
        index.Detail_OD = index.Detail_OD.split('</>').join(' ');
      }
    }
    if (returnFieldType == "example") docs = docs.filter(news => news.Topic_OD.replace(':', '') != question)
    results.newsList = docs;
    console.log(results)
    return results;
  }

  async searchWithLink(link: string): Promise<any> {
    const searchResponse: any = await lastValueFrom(this.fastApiRepository.getNewsByID(link));
    const docs = searchResponse.data.response.docs;

    if (docs.length) {
      let news: News = docs[0];
      let views: Map<string, number> = new Map();

      const viewsResponse: any = await lastValueFrom(this.getViews([news.Link_OD]));
      for (const [link, value] of Object.entries(viewsResponse.data)) {
        views.set(link, Number(value));
      }

      news.icon = await this.getFavicon(news.Link_OD);
      news.Detail_OD = news.Detail_OD.split('</>').join(' ');
      news.Views = views.get(news.Link_OD) ?? 0;

      return news;
    }
    else return new News();
  }

  getAutocomplete(input: string): Observable<any> {
    return this.fastApiRepository.getQuestionAutocomplete(input);
  }

  getTrending(): Observable<any> {
    return this.fastApiRepository.getTrendingQuestion();
  }

  saveHistory(link: string, userId: number): Observable<any> {
    return this.fastApiRepository.saveHistory(link, userId);
  }

  getDefaultImage(): string {
    return 'https://portal-atlasx.cdg.co.th/share/Downloads/ml-search-assests/ml-search-icon.png';
  }

  saveQuestion(question: string, userId: number): Observable<any> {
    if (question.length == 0 || question == '*') return new Observable();
    // let words: string[] = question.split(' ');
    // let text = "";
    // for(let i in words) {
    //   if(words[i] == "")  continue;
    //   if(text == "") {
    //     text = words[i];
    //     continue;
    //   }
    //   text += " " + words[i];
    // }
    return this.fastApiRepository.postQuestion(question, userId);
  }

  getNewsByLatLon(coords: { latitude: number, longitude: number }, limit: number): Observable<any> {
    return this.fastApiRepository.getNewsByPosition(coords.latitude, coords.longitude, limit);
  }

  getNLPshowcase(input: string): Observable<any> {
    return this.fastApiRepository.getNLP(input);
  }

  getHistory(): Observable<any> {
    return this.fastApiRepository.getHistory();
  }

  getHistoryTrending(limit = 8): Observable<any> {
    return this.fastApiRepository.getTrendingHistory(limit);
  }

  getNewsByIDs(Link_ODs : string[]): Observable<any> {
    return this.fastApiRepository.getNewsByIDs(Link_ODs);
  }

  getHistoryById(userId: number, limit: number): Observable<any> {
    return this.fastApiRepository.getQuestionByUserID(userId, limit);
  }

  getScrapingRequest(start: number, rows: number): Observable<any> {
    return this.fastApiRepository.getScrapingRequests(start, rows);
  }

  removeScrapingRequest(request_id: string): Observable<any> {
    return this.fastApiRepository.deleteScrapingRequest(request_id);
  }

  removeScrapingAttempt(attempt_id: string): Observable<any> {
    return this.fastApiRepository.deleteScrapingAttempt(attempt_id);
  }

  getNewsScriptsList(): Observable<any> {
    return this.fastApiRepository.getNewsScriptList();
  }

  getSocialMediaScriptsList(): Observable<any> {
    return this.fastApiRepository.getSocialMediaScriptList();
  }

  getCondoMockUpList(DataSource: string, ProjectName: string, PriceMax: number, PriceMin: number, Start: number, Row: number): Observable<any> {
    return this.fastApiRepository.getCondoMockUpList(DataSource, ProjectName, PriceMax, PriceMin, Start, Row);
  }

  //---------- Geocoding --------------
  getGeocoding(Location_Name: string, Source: string, Save: boolean): Observable<any> {
    return this.fastApiRepository.getGeocoding(Location_Name, Source, Save);
  }
  getGeocodeList(UpdateType:string,start:number , row:number , sortBy:string , sortOrder:string): Observable<any> {
    return this.fastApiRepository.getGeocodeList(UpdateType,start,row,sortBy,sortOrder);
  }
  // getGeocodeList(start:number , row:number , sortBy:string , sortOrder:string): Observable<any> {
  //   return this.fastApiRepository.getGeocodeList(start,row,sortBy,sortOrder);
  // }
  getGeocodeDatabaseFile(): Observable<any> {
    return this.fastApiRepository.getGeocodeDatabaseFile();
  }
  getGeocodeFile(Geocode_ID: string): Observable<any> {
    return this.fastApiRepository.getGeocodeFile(Geocode_ID);
  }
  uploadGeocodeFile(data:FormData): Observable<any> {
    return this.fastApiRepository.uploadGeocodeFile(data)
  }
  updateRecordStatus(Geocode_ID: string, Status: Boolean): Observable<any> {
    return this.fastApiRepository.updateRecordStatus(Geocode_ID, Status)
  }
  removeGeocode(Geocode_ID: string): Observable<any> {
    return this.fastApiRepository.removeGeocode(Geocode_ID)
  }

//--------------------//

  getDictionaryList(): Observable<any>{
    return this.fastApiRepository.getDictionaryList()
  }
  getDictionaryTreeList(start: number, row: number,sortBy: string,sortOrder: string): Observable<any>{
    return this.fastApiRepository.getDictionaryTreeList(start,row,sortBy,sortOrder)
  }
  activateDictionary(Dict_ID : string){
    return this.fastApiRepository.activateDictionary(Dict_ID)
  }
  removeDictionary(Dict_ID : string): Observable<any> {
    return this.fastApiRepository.removeDictionnary(Dict_ID)
  }
  downloadDictionary(Dict_ID: string){
    return this.fastApiRepository.downloadDictionary(Dict_ID)
  }
  uploadReplaceDictionaryFile(dict_data: FormData): Observable<any>{
    return this.fastApiRepository.uploadReplaceDictionaryFile(dict_data)
  }
  uploadAppendDictionaryFile(Dict_ID: string,dict_data: FormData): Observable<any>{
    return this.fastApiRepository.uploadAppendDictionaryFile(Dict_ID,dict_data)
  }

  // getFileScriptsList(): Observable<any> {
  //   return this.fastApiRepository.getFileScriptsList();
  // }

  // createScrapingRequest(data_source: string, start: number, stop: number): Observable<any> {
  //   return this.fastApiRepository.createScrapingRequest(data_source, start, stop);
  // }
  createNewsScrapingRequest(scrapingScript: string, extraObject: object) {
    console.log("extraObject : ", extraObject)
    return this.fastApiRepository.postNewsScrapingRequests(scrapingScript, extraObject);
  }

  createSocialMediaScrapingRequests(data: any) {
    return this.fastApiRepository.postSocialMediaScrapingRequests(data);
  }

  approveNewsFetching(request_id: string) {
    return this.fastApiRepository.approveNewsFetching(request_id);
  }

  approveNewsAnalyzing(request_id: string) {
    return this.fastApiRepository.approveNewsAnalyzing(request_id);
  }

  approveNewsSentiment(request_id: string) {
    return this.fastApiRepository.approveNewsSentiment(request_id);
  }

  approveNewsGeocoding(request_id: string) {
    return this.fastApiRepository.approveNewsGeocoding(request_id);
  }

  approveNewsSolrUpdate(request_id: string) {
    return this.fastApiRepository.approveNewsSolrUpdate(request_id);
  }

  restartNewsRequest(request_id: string) {
    return this.fastApiRepository.approveNewsRestart(request_id);
  }

  approveSocialMediaFetching(request_id: string) {
    return this.fastApiRepository.approveSocialMediaFetching(request_id);
  }

  approveSocialMediaAnalyzing(request_id: string) {
    return this.fastApiRepository.approveSocialMediaAnalyzing(request_id);
  }

  approveSocialMediaSentiment(request_id: string) {
    return this.fastApiRepository.approveSocialMediaSentiment(request_id);
  }

  approveSocialMediaGeocoding(request_id: string) {
    return this.fastApiRepository.approveSocialMediaGeocoding(request_id);
  }

  approveSocialMediaSolrUpdate(request_id: string) {
    return this.fastApiRepository.approveSocialMediaSolrUpdate(request_id);
  }

  restartSocialMediaRequest(request_id: string) {
    return this.fastApiRepository.approveSocialMediaRestart(request_id);
  }

  //Need to fix
  uploadFile(data: FormData) {
    return this.fastApiRepository.postFileScrapingRequests(data);
  }

  getFileScriptList(fileExtension: string) {
    return this.fastApiRepository.getFileScriptList(fileExtension);
  }

  approveFileAnalyzing(request_id: string) {
    return this.fastApiRepository.approveFileAnalyzing(request_id);
  }
  
  approveFileSentiment(request_id: string) {
    return this.fastApiRepository.approveFileSentiment(request_id);
  }

  approveFileGeocoding(request_id: string) {
    return this.fastApiRepository.approveFileGeocoding(request_id);
  }

  approveFileSolrUpdate(request_id: string) {
    return this.fastApiRepository.approveFileSolrUpdate(request_id);
  }

  restartFileRequest(request_id: string) {
    return this.fastApiRepository.approveFileRestart(request_id);
  }

  // getAnalysisData(attempt_id: string): Observable<any> {
  //   return this.fastApiRepository.getAnalysisData(attempt_id);
  // }

  getViews(links: string[]): Observable<any> {
    return this.fastApiRepository.getView(links);
  }

  getFormatViews(views: any): number {
    if (!views) return 0;
    if (views < 1000) return views;
    else {
      let temp = Math.floor(views / 100);
      return temp / 10;
    }
  }

  toNumber(views: string | number | undefined): number {
    if (views) return Number(views);
    else return 0;
  }

  async loadDataSourceJSON(): Promise<any> {
    return this.http.get<DataSource[]>('assets/scraping-source/data-source.json').toPromise();
  }

  async getFavicon(link: string): Promise<string> {
    const res = await this.loadDataSourceJSON();
    // console.log("getFavicon() Loaded Data Source:", res);
    for (let source of res) {
      if (link.includes(source.SourceURL)) {
        return source.SourceICON;
      }
    }
    return 'favicon.ico';
  }


  // getFavicon(link: string) {
  //   let text = link.split('/')
  //   let icon = ""
  //   for(let i of [0, 1, 2]) {
  //     icon += text[i] + '/'
  //   }
  //   if(text[2] == "www.thairath.co.th") icon += 'static/img/favicon/favicon-32x32.png'
  //   else icon += 'favicon.ico';

  //   return icon;
  // }

  getSourceDomain(link: string): string {
    if (link == "File") return link
    if (!link || link.trim() === '') {
      return 'NO SOURCE FOUND';
    }

    const parts = link.split('/');
    if (parts.length < 3) {
      return 'NO SOURCE FOUND';
    }

    const domain = parts[2];
    const domainParts = domain.split('.');
    if (domainParts.length < 2) {
      return 'NO SOURCE FOUND';
    }

    const source_name = link.split('/')[2].split('.')[1].toUpperCase()
    return source_name;
  }

  checkURL(link: string) {
    return this.fastApiRepository.chackURL(link);
  }
}

export interface SentimentResults {
  pos: number;
  neu: number;
  neg: number;
}
export class News {
  Detail_OD: string = "";
  Link_OD: string = "";
  Picture_Alt_OD: string[] = [];
  Picture_URL_OD: string[] = [];
  PublishDate_OD: string = "";
  LAT_LON_List: any[] = [];
  Topic_OD: string = "";
  Views: number = 0;
  icon: string = "";
  Location_List: string[] = [];
  LOCATION: string[] = [];
  PERSON: string[] = [];
  ScrapingType: string = "";
  sourceName: string = ""
  SentimentLabel: string = "";
  SentimentResults: SentimentResults = { pos: 0, neu: 0, neg: 0 };
}

export class Results {
  numFound: number = 0;
  newsList: News[] = [];
}

export class Color {
  r: number = 0;
  g: number = 0;
  b: number = 0;

  constructor(hex: string) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    this.set(r, g, b);
  }
  toString() { return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(this.b)})`; }

  set(r: number, g: number, b: number) {
    this.r = this.clamp(r);
    this.g = this.clamp(g);
    this.b = this.clamp(b);
  }

  hueRotate(angle = 0) {
    angle = angle / 180 * Math.PI;
    let sin = Math.sin(angle);
    let cos = Math.cos(angle);

    this.multiply([
      0.213 + cos * 0.787 - sin * 0.213, 0.715 - cos * 0.715 - sin * 0.715, 0.072 - cos * 0.072 + sin * 0.928,
      0.213 - cos * 0.213 + sin * 0.143, 0.715 + cos * 0.285 + sin * 0.140, 0.072 - cos * 0.072 - sin * 0.283,
      0.213 - cos * 0.213 - sin * 0.787, 0.715 - cos * 0.715 + sin * 0.715, 0.072 + cos * 0.928 + sin * 0.072
    ]);
  }

  grayscale(value = 1) {
    this.multiply([
      0.2126 + 0.7874 * (1 - value), 0.7152 - 0.7152 * (1 - value), 0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value), 0.7152 + 0.2848 * (1 - value), 0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value), 0.7152 - 0.7152 * (1 - value), 0.0722 + 0.9278 * (1 - value)
    ]);
  }

  sepia(value = 1) {
    this.multiply([
      0.393 + 0.607 * (1 - value), 0.769 - 0.769 * (1 - value), 0.189 - 0.189 * (1 - value),
      0.349 - 0.349 * (1 - value), 0.686 + 0.314 * (1 - value), 0.168 - 0.168 * (1 - value),
      0.272 - 0.272 * (1 - value), 0.534 - 0.534 * (1 - value), 0.131 + 0.869 * (1 - value)
    ]);
  }

  saturate(value = 1) {
    this.multiply([
      0.213 + 0.787 * value, 0.715 - 0.715 * value, 0.072 - 0.072 * value,
      0.213 - 0.213 * value, 0.715 + 0.285 * value, 0.072 - 0.072 * value,
      0.213 - 0.213 * value, 0.715 - 0.715 * value, 0.072 + 0.928 * value
    ]);
  }

  multiply(matrix: number[]) {
    let newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
    let newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
    let newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
    this.r = newR; this.g = newG; this.b = newB;
  }

  brightness(value = 1) { this.linear(value); }
  contrast(value = 1) { this.linear(value, -(0.5 * value) + 0.5); }

  linear(slope = 1, intercept = 0) {
    this.r = this.clamp(this.r * slope + intercept * 255);
    this.g = this.clamp(this.g * slope + intercept * 255);
    this.b = this.clamp(this.b * slope + intercept * 255);
  }

  invert(value = 1) {
    this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
    this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
    this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
  }

  hsl() { // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
    let r = this.r / 255;
    let g = this.g / 255;
    let b = this.b / 255;
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let h = (max + min) / 2;
    let s = (max + min) / 2;
    let l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      } h /= 6;
    }

    return {
      h: h * 100,
      s: s * 100,
      l: l * 100
    };
  }

  clamp(value: number) {
    if (value > 255) { value = 255; }
    else if (value < 0) { value = 0; }
    return value;
  }
}

export class Solver {
  target: Color;
  targetHSL: any;
  reusedColor: Color;
  constructor(target: Color = new Color(getComputedStyle(document.documentElement).getPropertyValue('--primary-banner'))) {
    this.target = target;
    this.targetHSL = target.hsl();
    this.reusedColor = new Color('#000000'); // Object pool
  }

  solve() {
    let result = this.solveNarrow(this.solveWide());
    return {
      values: result.values,
      loss: result.loss,
      filter: this.css(result.values)
    };
  }

  solveWide() {
    const A = 5;
    const c = 15;
    const a = [60, 180, 18000, 600, 1.2, 1.2];

    let best = { loss: Infinity };
    for (let i = 0; best.loss > 25 && i < 3; i++) {
      let initial = [50, 20, 3750, 50, 100, 100];
      let result = this.spsa(A, a, c, initial, 1000);
      if (result.loss < best.loss) { best = result; }
    } return best;
  }

  solveNarrow(wide: any) {
    const A = wide.loss;
    const c = 2;
    const A1 = A + 1;
    const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
    return this.spsa(A, a, c, wide.values, 500);
  }

  spsa(A: number, a: number[], c: number, values: number[], iters: number) {
    const alpha = 1;
    const gamma = 0.16666666666666666;

    let best = null;
    let bestLoss = Infinity;
    let deltas = new Array(6);
    let highArgs = new Array(6);
    let lowArgs = new Array(6);

    for (let k = 0; k < iters; k++) {
      let ck = c / Math.pow(k + 1, gamma);
      for (let i = 0; i < 6; i++) {
        deltas[i] = Math.random() > 0.5 ? 1 : -1;
        highArgs[i] = values[i] + ck * deltas[i];
        lowArgs[i] = values[i] - ck * deltas[i];
      }

      let lossDiff = this.loss(highArgs) - this.loss(lowArgs);
      for (let i = 0; i < 6; i++) {
        let g = lossDiff / (2 * ck) * deltas[i];
        let ak = a[i] / Math.pow(A + k + 1, alpha);
        values[i] = fix(values[i] - ak * g, i);
      }

      let loss = this.loss(values);
      if (loss < bestLoss) { best = values.slice(0); bestLoss = loss; }
    } return { values: best, loss: bestLoss };

    function fix(value: number, idx: number) {
      let max = 100;
      if (idx === 2 /* saturate */) { max = 7500; }
      else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) { max = 200; }

      if (idx === 3 /* hue-rotate */) {
        if (value > max) { value = value % max; }
        else if (value < 0) { value = max + value % max; }
      } else if (value < 0) { value = 0; }
      else if (value > max) { value = max; }
      return value;
    }
  }

  loss(filters: number[]) { // Argument is array of percentages.
    let color = this.reusedColor;
    color.set(0, 0, 0);

    color.invert(filters[0] / 100);
    color.sepia(filters[1] / 100);
    color.saturate(filters[2] / 100);
    color.hueRotate(filters[3] * 3.6);
    color.brightness(filters[4] / 100);
    color.contrast(filters[5] / 100);

    let colorHSL = color.hsl();
    return Math.abs(color.r - this.target.r)
      + Math.abs(color.g - this.target.g)
      + Math.abs(color.b - this.target.b)
      + Math.abs(colorHSL.h - this.targetHSL.h)
      + Math.abs(colorHSL.s - this.targetHSL.s)
      + Math.abs(colorHSL.l - this.targetHSL.l);
  }

  css(filters: any) {
    function fmt(idx: number, multiplier = 1) { return Math.round(filters[idx] * multiplier); }
    return `invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(2)}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(5)}%)`;
  }
}
